import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Typography, Grid } from '@material-ui/core'
import logo from '../../media/intergreens-logo.png'
import EmailIcon from '@material-ui/icons/Email'
import PhoneIcon from '@material-ui/icons/Phone'
import LocationOnIcon from '@material-ui/icons/LocationOn'

const Footer = () => {
  return (
    <Container component='footer' id='footer' maxWidth={false} disableGutters>
      <Container className='footer-top' maxWidth={false}>
        <Container className='footer-links' maxWidth='md'>
          <Link to='/about'>Meistä</Link>
          <Link to='/references'>Referenssit</Link>
          <Link to='/contact'>Ota yhteyttä</Link>
        </Container>
        <Container className='contact-details' maxWidth='md'>
          <h3>Ota yhteyttä</h3>
          <Grid container direction='row' spacing={1}>
            <Grid item>
              <EmailIcon />
            </Grid>
            <Grid item>
              <Typography>kalle@intergreens.com</Typography>
            </Grid>
          </Grid>
          <Grid container direction='row' spacing={1}>
            <Grid item>
              <PhoneIcon />
            </Grid>
            <Grid item>
              <Typography>+358 40 733 4720</Typography>
            </Grid>
          </Grid>
          <Grid container direction='row' spacing={1}>
            <Grid item>
              <LocationOnIcon />
            </Grid>
            <Grid item>
              <Typography>InterGREENS, Suursuontie 6 A 3, 00630 Helsinki</Typography>
            </Grid>
          </Grid>
        </Container>
      </Container>
      <Container className='footer-bottom' maxWidth={false}>
        <img alt='logo' className='logo' src={logo} />
        <p className='copyright'>InterGREENS &copy; 2021. All rights reserved.</p>
      </Container>
    </Container>
  )
}

export default Footer
